import React, { Component } from 'react';
import classnames from 'classnames';
import routes from '@achievable-me/tundra-wizard/routes';
import { reverse } from 'named-urls';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import ProductLayout from '$components/layout/ProductLayout';
import ScrollToTop from '$components/library/ScrollToTop';
import Seo from '$components/Seo';
import styles from './styles.scss';

const exams = [
  {
    name: 'FINRA SIE',
    description: 'Introductory exam for prospective securities industry professionals.',
    icon: 'fad fa-user-chart',
    slug: 'finra-sie',
  },
  {
    name: 'FINRA Series 6',
    description: 'Investment Company and Variable Contracts Products Representative Exam',
    icon: 'fad fa-money-check',
    slug: 'finra-series-6',
  },
  {
    name: 'FINRA Series 7',
    description:
      'Top-off exam for entry-level registered representatives in the securities industry.',
    icon: 'fad fa-money-check',
    slug: 'finra-series-7',
  },
  {
    name: 'FINRA Series 63',
    description: "The NASAA's Uniform Securities State Law Examination.",
    icon: 'fad fa-money-check',
    slug: 'finra-series-63',
  },
  {
    name: 'FINRA Series 65',
    description: "The NASAA's Uniform Investment Adviser Law Examination",
    icon: 'fad fa-money-check',
    slug: 'finra-series-65',
  },
  {
    name: 'FINRA Series 66',
    description: "The NASAA's Uniform Combined State Law Examination",
    icon: 'fad fa-money-check',
    slug: 'finra-series-66',
  },
  {
    name: 'GRE',
    description: 'Common requirement for graduate and graduate business programs.',
    icon: 'fad fa-user-tie',
    slug: 'gre',
  },
  {
    name: 'USMLE - Step 1',
    description:
      'First step of foundational sciences fundamental to the practice of medicine.',
    icon: 'fad fa-user-md',
    slug: 'usmle-step-1',
  },
  {
    name: 'AMC 8',
    description:
      'Math and problem-solving competition for students in grades 8 and below',
    icon: 'fad fa-function',
    slug: 'amc-8',
  },
  {
    name: 'AMC 10/12',
    description:
      'Math and problem-solving competition for students in grades 12 and below',
    icon: 'fad fa-function',
    slug: 'amc-12',
  },
  {
    name: 'Other',
    description: 'Interested in a different exam?',
    icon: 'fad fa-envelope-open-text',
    slug: 'other',
    comingSoon: true,
  },
];

class Catalog extends Component {
  constructor(props) {
    super(props);

    this.layoutRef = React.createRef();
  }

  renderExamTile = (data) => {
    const { comingSoon, name, description, icon, slug } = data;
    const to = reverse(routes.study.overview, { productSlug: slug });

    const buttonText = (() => {
      if (slug === 'other') {
        return 'Let us know';
      }

      return comingSoon ? 'Coming soon' : 'Overview';
    })();
    const buttonType = comingSoon ? 'secondary' : 'primary';

    const button = <Button type={buttonType}>{buttonText}</Button>;

    return (
      <div
        key={slug}
        className={classnames(styles.tile, comingSoon && styles.comingSoon)}
      >
        <i className={classnames(styles.tileIcon, icon)} />
        <div className={styles.tileName}>{name}</div>
        <div className={styles.tileDescription}>{description}</div>
        {comingSoon ? (
          <a
            href="https://achievable.typeform.com/to/BJc2i3"
            target="_blank"
            rel="noopener noreferrer"
          >
            {button}
          </a>
        ) : (
          <Link to={to} data-aaa={`${slug}-overview`}>
            {button}
          </Link>
        )}
      </div>
    );
  };

  render() {
    const { currentUser, location, match } = this.props;

    return (
      <>
        <Seo
          title="Exam catalog"
          canonical={reverse(routes.study.catalog, { productSlug: 'achievable' })}
          description="Achievable produces test prep content for a variety of exams. Browse our live products and see what we're currently developing."
        />
        <ProductLayout currentUser={currentUser} location={location} match={match}>
          {({ product }) => {
            return (
              <ScrollToTop elementRef={this.layoutRef}>
                <div ref={this.layoutRef} className={styles.layout}>
                  <div className={styles.layout}>
                    <h1 className={styles.header}>Exam catalog</h1>
                    <div className={styles.description}>
                      If you&apos;d like to see an exam not listed here,{' '}
                      <Link
                        to={reverse(routes.study.feedback, { productSlug: product.slug })}
                      >
                        let us know
                      </Link>
                      !
                    </div>
                  </div>
                  <div className={styles.tiles}>
                    {exams.map((exam) => this.renderExamTile(exam))}
                  </div>
                </div>
              </ScrollToTop>
            );
          }}
        </ProductLayout>
      </>
    );
  }
}

export default Catalog;
